import React from "react";
import { CurrencyLabel, StatusBadge } from "../../components";
import dayjs from "dayjs";
import { GRID_COLUMN_EMPTY_ICONS } from "../../utils/Constants";

// Smart Plans Status Constants
export const PLAN_STATUS = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
};

export const PAYMENT_STATUS = {
  SUCCESS: "Success",
  FAILED: "Failed",
  PENDING: "Pending",
};

export const FREQUENCY_TYPE = {
  MONTHLY: "Monthly",
  TERM: "Term",
};

// Column definitions for AG Grid
export const COLUMN_DEFS = [
  {
    headerName: "Plan name",
    field: "beneficiary.grade",
    valueFormatter: (params) => {
      const grade = params.data?.beneficiary?.grade;
      return grade ? `Smart Plan / ${grade}` : "";
    },
    sortable: true,
    unSortIcon: true,
    suppressMenu: true,
    icons: GRID_COLUMN_EMPTY_ICONS,
    pinned: "left",
    flex: 1,
    minWidth: 180,
  },
  {
    headerName: "Student ID",
    field: "beneficiary.studentId",
    valueFormatter: (params) => {
      return params.data?.beneficiary?.studentId ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Student name",
    field: "beneficiary.name",
    valueFormatter: (params) => {
      return params.data?.beneficiary?.name ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 160,
  },
  {
    headerName: "Grade",
    field: "beneficiary.grade",
    valueFormatter: (params) => {
      return params.data?.beneficiary?.grade ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Monthly/Termly",
    field: "productDetails.type",
    valueFormatter: (params) => {
      return params.data?.productDetails?.type ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Start date",
    field: "startDate",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const d = dayjs(params.value);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 130,
  },
  {
    headerName: "Total amount",
    field: "totalAmount",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 130,
    cellRenderer: (params) => <CurrencyLabel amount={params.value ?? 0} />,
  },
  {
    headerName: "Due Amount",
    field: "dueAmount",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 140,
    cellRenderer: (params) => <CurrencyLabel amount={params.value ?? 0} />,
  },
  // {
  //   headerName: "Current month/term",
  //   field: "nextPaymentDate",
  //   sortable: false,
  //   filter: false,
  //   suppressMenu: true,
  //   flex: 1,
  //   minWidth: 180,
  // },
  {
    headerName: "Last payment",
    field: "lastPaymentDate",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const d = dayjs(params.value);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Last payment status",
    field: "lastPaymentStatus",
    cellRenderer: (params) => <StatusBadge status={params.value} />,
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 170,
  },
  {
    headerName: "Next payment",
    field: "nextPaymentDate",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const d = dayjs(params.value);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Plan Status",
    field: "status",
    sortable: false,
    filter: false,
    suppressMenu: true,
    pinned: "right",
    flex: 1,
    minWidth: 110,
  },
];

export const PAGE_ROUTE = {
  SMART_PLANS: "/skiply-portal/SmartPlans",
}

// Search/Filter options
export const SEARCH_CATEGORIES = [
  { label: "Student Name", value: "studentName" },
  { label: "Student ID", value: "studentId" },
  { label: "User ID", value: "userId" },
];

export const STATUS_FILTER_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Active", value: PLAN_STATUS.ACTIVE },
  { label: "Cancelled", value: PLAN_STATUS.CANCELLED },
  { label: "Completed", value: PLAN_STATUS.COMPLETED },
];
